import type { GetProjectsParams } from '@/interfaces/projects.interface';

/** Debounce delay for projects table server search (ms). */
export const PROJECTS_TABLE_SEARCH_DEBOUNCE_MS = 500;

/** Default rows per page for the projects DataTable. */
export const PROJECTS_TABLE_DEFAULT_PAGE_SIZE = 10;

/** Page size for project picker dropdown (lazy-loaded pages). */
export const PROJECT_DROPDOWN_PAGE_SIZE = 20;

/**
 * Default query when `useProjects()` is called with no params (project selector,
 * context, admin lists). Server-side pagination: one large page so typical tenants
 * see their full project list without extra round-trips.
 */
export const DEFAULT_GLOBAL_PROJECT_LIST_PARAMS = {
  page: 1,
  size: 100,
} as const satisfies GetProjectsParams;
